var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "#A5A5A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -90.5,
    y: -59.5,
    width: 148,
    height: 138,
    rx: 7.5,
    fill: "#F5F5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -90.5,
    y: -59.5,
    width: 148,
    height: 138,
    rx: 7.5,
    fill: "#E9EBF6",
    fillOpacity: 0.03
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -90.5,
    y: -59.5,
    width: 148,
    height: 138,
    rx: 7.5,
    stroke: "#B4BAC2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 17,
    height: 17,
    rx: 3.5,
    fill: "#F5F5F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 17,
    height: 17,
    rx: 3.5,
    fill: "#E9EBF6",
    fillOpacity: 0.03
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 17,
    height: 17,
    rx: 3.5,
    stroke: "#B4BAC2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 4,
    width: 11,
    height: 11,
    rx: 1,
    fill: "#3E404D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 4,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3E404D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelected);
export default __webpack_public_path__ + "static/media/checkbox-selected.ffd3ad7815ff779eba92db95c3d79a59.svg";
export { ForwardRef as ReactComponent };